import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const AgentHandoffButton = ({ label, onClick, disabled }) => (
  <Box sx={{ mt: 1, mb: 0.5 }}>
    <Button
      variant="outlined"
      size="small"
      endIcon={<ArrowForwardIcon />}
      onClick={onClick}
      disabled={disabled}
      sx={{
        textTransform: 'none',
        borderRadius: '8px',
        fontWeight: 500,
        fontSize: { xs: '0.8rem', md: '0.875rem' },
      }}
    >
      {label}
    </Button>
  </Box>
);

AgentHandoffButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default AgentHandoffButton;
